<div class="not-found-text">
  <h1>Page Not Found</h1>

  <p>
    The page you are trying to access is not available.
  </p>

  <p>
    You may have entered an incorrect URL or the page may no longer exist. Please check your URL or return to the <a [routerLink]="[homeUrl]">Home Page</a>.
  </p>

  <p>
    If you are experiencing technical difficulties, please visit the Board's <a href="http://www.wcb.ny.gov/content/ebiz/information/contact_wcb.jsp">Technical Support</a> page.
  </p>
</div>
